import burger1 from "../image/burger1.png";
import burger2 from "../image/burger2.png";
import burger3 from "../image/burger3.png";
import burger4 from "../image/burger4.png";
import burger5 from "../image/burger5.png";
import burger6 from "../image/burger6.png";
import burger7 from "../image/burger7.png";

import pizza1 from "../image/pizza1.png";
import pizza2 from "../image/pizza2.png";
import pizza3 from "../image/pizza3.png";
import pizza4 from "../image/pizza4.png";
import pizza5 from "../image/pizza5.png";

import side1 from "../image/side1.png";
import side2 from "../image/side2.png";
import side3 from "../image/side3.png";
 import side4 from "../image/side4.png";
import side5 from "../image/side5.png";

import drink1 from "../image/drink1.png";
import drink2 from "../image/drink2.png";
import drink3 from "../image/drink3.png";
 import drink4 from "../image/drink4.png";
 import drink5 from "../image/drink5.png";
 import drink6 from "../image/drink6.png";


import offer1 from "../image/offer1.png";
import offer2 from "../image/offer2.png";
import offer3 from "../image/offer3.png";
import offer4 from "../image/offer4.png";



export const burgerProducts = [
  {
    id: "01",
    title: "Double Cheese Burger",
    price: 12000,
    imgUrl: burger1,

  },
  {
    id: "02",
    title: "2in1 Cheese Burger",
    price: 9000,
    imgUrl: burger2,

  },

  {
    id: "03",
    title: "Caesar Chicken Burger",
    price: 8000,
    imgUrl: burger3,

  },

  {
    id: "04",
    title: "Chicken Burger",
    price: 8000,
    imgUrl: burger4,

  },
  {
    id: "05",
    title: "Chili Con Carne Cheese Burger",
    price: 9000,
    imgUrl: burger5,

  },
  {
    id: "06",
    title: "Fram Burger",
    price: 10000,
    imgUrl: burger6,

  },
  {
    id: "07",
    title: "Vegetable Burger",
    price: 6000,
    imgUrl: burger7,

  },
];

export const pizzaProducts = [
  {
    id: "08",
    title: "Mexican Pizza",
    price: 10000,
    imgUrl: pizza1,

  },
  {
    id: "09",
    title: "Margheita Pizza",
    price: 7000,
    imgUrl: pizza2,

  },
  {
    id: "10",
    title: "Vegetable Pizza",
    price: 8000,
    imgUrl: pizza3,

  },
  {
    id: "11",
    title: "Truffle Pizza",
    price: 10000,
    imgUrl: pizza4,

  },
  {
    id: "12",
    title: "Mixed Pizza",
    price: 10500,
    imgUrl: pizza5,

  },
];

export const desertProducts = [
  {
    id: "13",
    title: "French Fries",
    price: 2000,
    imgUrl: side5,
  },
  {
    id: "14",
    title: "Cheese French Fries",
    price: 4000,
    imgUrl: side4,
  },
  {
    id: "15",
    title: "Crazy Fries",
    price: 5000,
    imgUrl: side3,
  },
  {
    id: "16",
    title: "Onion Ring",
    price: 4000,
    imgUrl: side2,
  },
  {
    id: "17",
    title: "Chicken Popcorn",
    price: 50,
    imgUrl: side1,
  },
];

export const drinkProducts = [
  {
    id: "17",
    title: "Pepsi",
    price: 1000,
    imgUrl: drink1,
  },
  {
    id: "18",
    title: "Diet Pepsi",
    price: 1000,
    imgUrl:drink2,
  },
  {
    id: "19",
    title: "Mountain Dew",
    price: 1000,
    imgUrl: drink3,
  },
  {
    id: "20",
    title: "7up",
    price: 1000,
    imgUrl: drink4,
  },
  {
    id: "25",
    title: "Mirnda",
    price: 1000,
    imgUrl: drink5,
  },
  {
    id: "26",
    title: "Mineral Water",
    price: 1000,
    imgUrl: drink6,
  },
];

export const offerProducts = [
  {
    id: "21",
    title: "Swiss Mushroom Burger",
    price: 9500,
    imgUrl: offer1,
  },
  {
    id: "22",
    title: "Grilled Chicken Burger",
    price: 8000,
    imgUrl: offer2,
  },
  {
    id: "23",
    title: "Zhoopper Combo Burger",
    price: 9500,
    imgUrl: offer3,
  },
  {
    id: "24",
    title: "1 Chicken Burger 1 Cheese Burger",
    price: 16500,
    imgUrl:offer4,

  },

];
export const popularProducts = [
  {
    id: "01",
    title: "Double Cheese Burger",
    price: 12000,
    imgUrl: burger1,

  },
  {
    id: "22",
    title: "Grilled Chicken Burger",
    price: 8000,
    imgUrl: offer2,
  },
  {
    id: "08",
    title: "Mexican Pizza",
    price: 10000,
    imgUrl: pizza1,

  },
  {
    id: "21",
    title: "Swiss Mushroom Burger",
    price: 9500,
    imgUrl: offer1,
  },

];

